/**
 * @desc 分页条件查询sku列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.PlmSkuListResponseDto>
>;
export function request(
  body: defs.basics.PlmSkuRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/page`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
